<template>
  <div class="ready">
    <div class="video__wrapper">
      <transition name="fade">
        <TestvIntro v-if="ended" class="comp__TestvIntro"/>
        <div v-else-if="showLoading" class="prepare__wrapepr">
          <IconLogoTestv class="icon__testv"/>
          <div class="loading__wrapper">
            <IconLoading class="icon__loading"/>
            <span>小伙伴们正在赶来…</span>
          </div>
        </div>
        <div v-else-if="paused" class="prepare__wrapepr">
          <IconLogoTestv class="icon__testv"/>
          <div class="btn__play__wrapper">
            <SsButton2 class="btn__play" @click="play">
              <IconPlay class="icon__play"/>
            </SsButton2>
            <span>立即进入</span>
          </div>
        </div>
      </transition>
      <video
        id="openVideo"
        ref="video"
        :class="{
          'openVideo--ended': ended,
          'openVideo--fadeEnded': fadeEnded
        }"
        playsinline
        preload="auto"
        @loadedmetadata="onCanplay"
        @ended="onEnded">
        <source src="https://cdn-static.sspai.com/page/testv/assets/open.mp4" type="video/mp4"/>
      </video>
      <transition name="fade">
        <div v-if="!ended" class="btn__seek__wrapper">
          <SsButton2 class="btn__seek" @click="seek">
            <span>跳过视频</span>
          </SsButton2>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import TestvIntro from '@/components/TestvIntro'
export default {
  name: 'Ready',

  components: {
    TestvIntro
  },

  data () {
    return {
      showLoading: false,
      canPlay: false,
      paused: true,
      ended: false,
      fadeEnded: false
    }
  },

  methods: {
    play () {
      this.$refs.video.play()
        .then(() => {
          this.paused = false
        })
        .catch(error => {
          console.log(error)
          this.paused = true
        })
    },
    onCanplay () {
      this.canPlay = true
      this.play()
    },
    onEnded () {
      this.ended = true
      this.fadeEnded = true
    },
    seek () {
      this.ended = true
      this.$refs.video.pause()
    },
    replay () {
      this.ended = false
      this.$refs.video.currentTime = 0
      this.play()
    }
  },

  created () {
    setTimeout(() => {
      if (!this.canPlay) {
        this.showLoading = true
      }
    }, 1000)
  },

  mounted () {
    document.documentElement.style.height = `${window.innerHeight}px`
    document.documentElement.style.overflow = 'hidden'
    window.openVideoSeek = this.seek
    window.openVideoReplay = this.replay
  },

  destroyed () {
    document.documentElement.style.height = ''
    document.documentElement.style.overflow = ''
  }
}
</script>

<style lang="stylus" scoped>
.prepare__wrapepr,
.video__wrapper {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}
.prepare__wrapepr {
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--dark-bwb-0);
  .icon__testv {
    width: 100%;
    color: #fff;
    opacity: 0.02;
  }
  .btn__play__wrapper,
  .loading__wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 16px;
    font-size: 24px;
    font-weight: 500;
    .icon__loading {
      width: 80px;
      color: #fff;
      animation: rotate 1.5s infinite;
    }
    .icon__play {
      width: 48px;
      color: var(--dark-bwb-0);
    }
    .btn__play {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 80px;
      border-radius: 4px;
      background: var(--yellow-testv);
      &:not(:hover) {
        .icon__play {
          animation: breath 1s infinite alternate;
        }
      }
    }
  }
}
.video__wrapper {
  video {
    width: 100%;
    height: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all .3s ease;
}
.fade-enter-active {
  transition-delay: 0.3s;
}
.fade-enter
.fade-leave-to {
  opacity: 0;
}

@keyframes breath {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

#openVideo {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  z-index: 2;
}
#openVideo.openVideo--ended {
  opacity: 0;
}
#openVideo.openVideo--fadeEnded {
  transition: opacity 0.3s
}

.btn__seek__wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 64px;
  z-index: 5;
}

.btn__seek {
  width: 92px;
  height: 40px;
  border-radius: 10px;
  background: #48494C;
  font-size: 17px;
  font-weight: 500;
  color: #fff;
}
</style>
